import { takeLatest, put, call, select } from "redux-saga/effects";
import axios from "../../utils/axios";
import log from "loglevel";
import messages from "../../assets/i18n";

import getEnvParam from "../../utils/getEnvParam";

const providersFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

function* providers(payload, token) {
	try {
		const { nome, cnpj } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
                fornecedoresFiltrados(
					nome: "${nome ? nome : ""}", 
					cnpj: "${cnpj ? cnpj : ""}"
				) {
                    id	
                    nome
                    cnpj
                    cidade
                    uf
                    ediPoInd
                    exigirDeclProdutor
					exigirCertifOrigem
					isSubcontratado
                }
			}`
		};

		const data = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* subcontractorFlag(payload, token) {
	try {
		const { fornecedorId, isSubcontratado } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				atualizarFlagSubcontratado(fornecedorId: ${fornecedorId}, isSubcontratado: ${isSubcontratado}) {
					id
				}
			}`
		};

		const { data } = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* declaracaoProdutor(payload, token) {
	try {
		const { fornecedorId, exigirDeclProdutor } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				atualizarFlagDeclaracaoProdutor(fornecedorId: ${fornecedorId}, exigirDeclProdutor: ${exigirDeclProdutor}) {
					id
				}
			}`
		};

		const data = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* certifOrigem(payload, token) {
	try {
		const { fornecedorId, exigirCertifOrigem } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				atualizarFlagCertificadoOrigem(fornecedorId: ${fornecedorId}, exigirCertifOrigem: ${exigirCertifOrigem}) {
					id
				}
			}`
		};

		const data = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* providersBySubcontractor(payload, token) {
	try {
		const { subcontractorId } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
                buscarFornecedorPorSubcontratado(
					idSubcontratado: ${subcontractorId}
				) {
                    id	
                    nome
                    cnpj
                }
			}`
		};

		const { data } = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* providersNotLinkedSubcontractor(payload, token) {
	try {
		const { subcontractorId } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
                buscarFornecedorNaoVinculadoAoSubcontratado(
					idSubcontratado: ${subcontractorId}
				) {
                    id	
                    nome
                    cnpj
                }
			}`
		};

		const { data } = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getProviders(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const lang = yield select(state => state.language.name);

		yield put({ type: "SET_LOADING_PROVIDER_LIST", payload: true});
        
		yield put({ type: "CLEAN_PROVIDER_LIST", payload: { fornecedoresFiltrados: [] } });

		const result = yield call(providers, payload.filter, token);

		if (result && result.data) {
            yield put({ type: "SET_PROVIDER_LIST", payload: result.data});
        } else {
            yield put({ 
                type: "SET_PROVIDER_TOAST", 
                payload: {
                    showToast: true,
                    message: result.errors ? result.errors[0].message : messages[lang].internalError,
                    messageType: "toast-error"
                }});
		}

		yield put({ type: "SET_LOADING_PROVIDER_LIST", payload: false});
	} catch (error) {
		log.info(error);
		yield put({ type: "SET_LOADING_PROVIDER_LIST", payload: false});
	}
}

function* updateDeclaracaoProdutor(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const lang = yield select(state => state.language.name);

        yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: true});
		
		const result = yield call(declaracaoProdutor, payload.payload, token);

		if (result.errors) {
            yield put({ 
                type: "SET_PROVIDER_TOAST", 
                payload: {
                    showToast: true,
                    message: result.errors ? result.errors[0].message : messages[lang].internalError,
                    messageType: "toast-error"
                }});
		}

        yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: false});
	} catch (error) {
		log.info(error);
	}
}

function* updateExigirCertifOrigem(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const lang = yield select(state => state.language.name);

        yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: true});
		
		const result = yield call(certifOrigem, payload.payload, token);

		if (result.errors) {
            yield put({ 
                type: "SET_PROVIDER_TOAST", 
                payload: {
                    showToast: true,
                    message: result.errors ? result.errors[0].message : messages[lang].internalError,
                    messageType: "toast-error"
                }});
		}

        yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: false});
	} catch (error) {
		log.info(error);
	}
}

function* updateSubcontractorFlag(payload) {
	try {
		const { token } = yield select(state => state.authentication);

        yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: true});

		yield call(subcontractorFlag, payload.payload, token);

        yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: false});
	} catch (error) {
		log.info(error);
	}
}

function* getProvidersBySubcontractor(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        
		yield put({ type: "CLEAN_PROVIDERS_BY_SUBCONTRACTOR" });
		yield put({ type: "SET_LOADING_PROVIDERS_BY_SUBCONTRACTOR", payload: true });

		const result = yield call(providersBySubcontractor, payload.payload, token);

		if (result) {
            yield put({ type: "SET_FETCHED_PROVIDERS_BY_SUBCONTRACTOR", payload: result});
        }
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_LOADING_PROVIDERS_BY_SUBCONTRACTOR", payload: false });
	}
}

function* getProvidersNotLinkedSubcontractor(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        
		yield put({ type: "CLEAN_PROVIDERS_NOT_LINKED_SUBCON" });
		yield put({ type: "SET_LOADING_PROVIDERS_NOT_LINKED_SUBCON", payload: true });

		const result = yield call(providersNotLinkedSubcontractor, payload.payload, token);

		if (result) {
            yield put({ type: "SET_FETCHED_PROVIDERS_NOT_LINKED_SUBCON", payload: result});
        }
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_LOADING_PROVIDERS_NOT_LINKED_SUBCON", payload: false });
	}
}


function* addProviderSubcontractor(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        
		yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: true });

		const result = yield call(vincularSubcontratado, payload.payload, token);

		if (result) {
            yield put({ type: "SET_RELOAD_PROVIDER_LIST"});
			yield put({ type: "SET_RELOAD_SUBCONTRACTOR_LIST"});
        }
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: false });
	}
}


function* vincularSubcontratado(payload, token) {
	try {
        const { 
            fornecedorId,
			subcontratadoId
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    vincularSubcontratado (
                            fornecedorId: ${fornecedorId}
                            subcontratadoId: "${subcontratadoId}"
                    ){
                        id                        
                    }
                }
            `
		};

		const { data } = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* removeProviderSubcontractor(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        
		yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: true });

		const result = yield call(desvincularSubcontratado, payload.payload, token);

		if (result) {
            yield put({ type: "SET_RELOAD_PROVIDER_LIST"});
			yield put({ type: "SET_RELOAD_SUBCONTRACTOR_LIST"});
        }
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_LOADING_PROVIDER_UPDATE", payload: false });
	}
}

function* desvincularSubcontratado(payload, token) {
	try {
        const { 
            fornecedorId,
			subcontratadoId
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_FORNECEDOR"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    desvincularSubcontratado (
                            fornecedorId: ${fornecedorId}
                            subcontratadoId: "${subcontratadoId}"
                    ){
                        id                        
                    }
                }
            `
		};

		const { data } = yield call(providersFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

// //Generator function
export function* providerWatcher() {
	yield takeLatest("GET_PROVIDERS", getProviders);
	yield takeLatest("UPDATE_DECLARACAO_PRODUTOR", updateDeclaracaoProdutor);
	yield takeLatest("UPDATE_SUBCONTRACTOR_FLAG", updateSubcontractorFlag);
	yield takeLatest("GET_PROVIDERS_BY_SUBCONTRACTOR", getProvidersBySubcontractor);
	yield takeLatest("GET_PROVIDERS_NOT_LINKED_SUBCON", getProvidersNotLinkedSubcontractor);
	yield takeLatest("ADD_PROVIDER_SUBCONTRACTOR", addProviderSubcontractor);
	yield takeLatest("REMOVE_PROVIDER_SUBCONTRACTOR", removeProviderSubcontractor);
	yield takeLatest("UPDATE_EXIGIR_CERTIF_ORIGEM", updateExigirCertifOrigem);
}
